import { ChainId } from '@pancakeswap/sdk'

export const SUPPORT_ONLY_BSC = [ChainId.MANTLE, ChainId.MANTLE_TESTNET]
export const SUPPORT_FARMS = [ChainId.MANTLE, ChainId.MANTLE_TESTNET]
